import React, { ReactNode } from 'react';
import { Icon, Button } from '@tencent/spaui';
import { report } from 'store/report';

import './info-common.scss';

interface Props {
  nextStep?: ReactNode;
  onSubmit?: (data: any) => void;
  initData?: { [key: string]: any };
}

// 基本信息
const BaseInfo: React.FC<Props> = () => {
  return (
    <div>
      <div className="info-content" style={{ textAlign: 'center' }}>
        <div>
          <Icon name="check-filled" style={{ color: '#5AC724', width: '80px', height: '80px' }} />
        </div>
        <h3 style={{ padding: '40px 0 12px', fontSize: '20px' }}>感谢您，成功注册腾讯广告营销服务市场！</h3>
        <div>您可以访问腾讯广告营销服务市场服务商管理后台，了解合作相关规则，查看应用状态及信息管理等</div>
        <Button
          displayType="primary"
          style={{ marginTop: '63px', width: '200px' }}
          onClick={() => {
            report({ event: 'regist_page', payload: '进入服务商系统' });
            (window as any).location.href = `https://sso.e.qq.com/login/hub?sso_redirect_uri=${encodeURIComponent(
              location.origin
            )}/manage?source=regist&service_tag=80`;
          }}
        >
          服务商管理后台
        </Button>
      </div>
    </div>
  );
};

export default BaseInfo;
